<template>
  <div class="all-center-box">
    <div class="w-1500">
      <div class="address-box w-100">
        <router-link to="/">首页</router-link> / <a>留言或投诉</a>
      </div>
      <div class="page-center-box w-100">
        <div class="ksbj-box1 w-100">
          <div class="box-info1 w-100">— 留言或投诉 —</div>
          <div class="box-info2 w-100 between-center">
            <form action="" class="pull-left" method="post">
              <div
                class="box1 w-100"
                style="display: flex; align-items: center"
              >
                <span><i>*</i> 留言类型：</span>
                <div class="group">
                  <el-radio v-model="formData.type" :label="1">投诉</el-radio>
                  <el-radio v-model="formData.type" :label="2">留言</el-radio>
                </div>
              </div>
              <div
                class="box1 w-100"
                style="display: flex; align-items: center"
                v-if="formData.type === 1"
              >
                <span><i>*</i> 投诉类型：</span>
                <!-- <el-checkbox-group v-model="checkList">
                  <el-checkbox
                    v-for="item in optionsList"
                    :value="item.id"
                    :label="item.value"
                    :key="item.id"
                  ></el-checkbox>
                </el-checkbox-group> -->
                <el-select v-model="formData.categoryId">
                  <el-option
                    v-for="item in optionsList"
                    :value="item.id"
                    :label="item.value"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="box1 w-100" style="display: flex">
                <span><i>*</i> 留言或投诉：</span>
                <el-input
                  style="width: 82%"
                  type="textarea"
                  :rows="10"
                  placeholder="请输入留言或投诉"
                  v-model="formData.content"
                >
                </el-input>
              </div>
              <input class="btns" value="提交" @click="undeveloped" />
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addMessage, getDictionary } from '../../common/http';

export default {
  props: {

  },
  data () {
    return {
      formData: {
        type: 1,
        content: '',
        categoryId: '',
        // opinion: '这是一个测试留言'
      },
      checkList: [],
      optionsList: []
    };
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.getDictionaryList();
  },
  watch: {

  },
  methods: {
    getDictionaryList () {
      getDictionary({ code: 'complaint' }).then(res => {
        if (res.result) {
          this.optionsList = res.data[0].sysDictData
        }
      })
    },
    undeveloped () {
      if (this.formData.content === '') {
        this.$message.error("请输入留言或投诉内容！")
        return
      }
      addMessage(this.formData).then(res => {
        if (res.result) {
          this.$message.success("我们已收到您的留言和反馈，感谢支持！")
          this.formData = {
            type: 1,
            content: '',
            categoryId: ''
          }
        }
      })
    }
  },
  components: {

  },
};
</script>

<style scoped>
.ksbj-box1 {
  background: #fff;
  padding: 2.8125rem;
  min-height: 34.375rem;
}

.ksbj-box1 .box-info1 {
  font-size: 1.125rem;
  font-weight: bold;
  padding-bottom: 1rem;
}

.ksbj-box1 .box-info2 .pull-left {
  width: 52%;
  font-size: 0.875rem;
}

.ksbj-box1 .box-info2 .pull-left .box1 {
  margin-top: 1.25rem;
  padding: 0 1.25rem;
}

.ksbj-box1 .box-info2 .pull-left .box1 span {
  width: 18%;
  float: left;
  line-height: 2.5rem;
}

.ksbj-box1 .box-info2 .pull-left .box1 span i {
  color: red;
}

.ksbj-box1 .box-info2 .pull-left .box1 .text {
  width: 82%;
  float: left;
  height: 2.5rem;
  border: 2px solid #c9c9c9;
  padding: 0 0.625rem;
}

.ksbj-box1 .box-info2 .pull-left .box1 select {
  width: 82%;
  float: left;
  height: 2.5rem;
  border: 2px solid #c9c9c9;
  padding: 0 0.4rem;
}

.ksbj-box1 .box-info2 .pull-left .box1.yzm .text {
  width: 65%;
}

.ksbj-box1 .box-info2 .pull-left .box1.yzm img,
.ksbj-box1 .box-info2 .pull-left .box1.yzm a {
  width: 15%;
  float: right;
  height: 2.5rem;
  border: 2px solid #c9c9c9;
  line-height: 2.5rem;
  text-align: center;
  background: #e0e0e0;
  cursor: pointer;
  color: #333;
  font-size: 14px;
}

.ksbj-box1 .box-info2 .pull-left .box2 {
  margin-top: 1.5625rem;
}

.ksbj-box1 .box-info2 .pull-left .box3 {
  background: #e5f0f9;
  padding-bottom: 1.25rem;
  margin-top: 1.25rem;
}

.ksbj-box1 .box-info2 .pull-left .box4 select + select {
  margin-left: 1rem;
}

.ksbj-box1 .box-info2 .pull-left .box4 input + input {
  margin-left: 1rem;
}

.ksbj-box1 .box-info2 .pull-left .box5 {
  width: 82%;
  float: left;
}

.ksbj-box1 .box-info2 .pull-left .box5 label {
  width: 100%;
  float: left;
  margin: 0.7rem 0 0 0;
}

.ksbj-box1 .box-info2 .pull-left .box6 {
  width: 100%;
  float: left;
  padding-left: 20px;
  display: none;
}

.ksbj-box1 .box-info2 .pull-left .box6 .box1 {
  padding: 0 20px 0 0;
  margin-top: 1rem;
}

.ksbj-box1 .box-info2 .pull-left .box6 .box1 span {
  width: 22%;
  line-height: 1.875rem;
  height: 1.875rem;
}

.ksbj-box1 .box-info2 .pull-left .box6 .box1 .text {
  width: 78%;
  line-height: 1.875rem;
  height: 1.875rem;
}

.ksbj-box1 .box-info2 .pull-left .box7 {
  border-top: 1px solid #d3d3d3;
  font-size: 14px;
  padding: 0.75rem 0 0;
  margin-top: 1.375rem;
  text-align: center;
  color: #999;
}

.ksbj-box1 .box-info2 .pull-left .box7 a {
  color: #999;
}

.ksbj-box1 .box-info2 .pull-left .box7 a:hover {
  color: #004194;
}

.ksbj-box1 .box-info2 .pull-left .btns {
  width: 100%;
  text-align: center;
  float: left;
  height: 2.875rem;
  line-height: 2.875rem;
  cursor: pointer;
  background: #004194;
  border: none;
  color: #fff;
  font-size: 1.125rem;
  margin-top: 1.375rem;
}

.ksbj-box1 .box-info2 .pull-right {
  width: 38%;
}

.ksbj-box1 .box-info2 .pull-right .between-center {
  padding: 1rem 0;
}

.ksbj-box1 .box-info2 .pull-right .between-center img {
  height: 4.625rem;
}

.ksbj-box1 .box-info2 .pull-right .between-center div {
  width: 100%;
  padding-left: 1.125rem;
  font-size: 1.125rem;
  line-height: 1.8;
}

.ksbj-box1 .box-info2 .pull-right .between-center div a {
  color: #ffb300;
}
</style>



// WEBPACK FOOTER //
// src/pages/userCenter/userServers.vue